import { render, staticRenderFns } from "./FilesDropdown.vue?vue&type=template&id=6487f427"
import script from "./FilesDropdown.vue?vue&type=script&lang=js"
export * from "./FilesDropdown.vue?vue&type=script&lang=js"
import style0 from "./FilesDropdown.vue?vue&type=style&index=0&id=6487f427&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports